module.exports = __webpack_public_path__ + "Peter Wei-73bef725.png";